import { CountryCodes } from '@/store/openAccount/types';

const countryCodesList: CountryCodes[] = [
  {
      name: 'Afghanistan',
      value: '+93',
      text: '+93 (Afghanistan)',
  },
  {
      name: 'Aland Islands',
      value: '+358',
      text: '+358 (Aland Islands)',
  },
  {
      name: 'Albania',
      value: '+355',
      text: '+355 (Albania)',
  },
  {
      name: 'Algeria',
      value: '+213',
      text: '+213 (Algeria)',
  },
  {
      name: 'AmericanSamoa',
      value: '+1684',
      text: '+1684 (AmericanSamoa)',
  },
  {
      name: 'Andorra',
      value: '+376',
      text: '+376 (Andorra)',
  },
  {
      name: 'Angola',
      value: '+244',
      text: '+244 (Angola)',
  },
  {
      name: 'Anguilla',
      value: '+1264',
      text: '+1264 (Anguilla)',
  },
  {
      name: 'Antarctica',
      value: '+672',
      text: '+672 (Antarctica)',
  },
  {
      name: 'Antigua and Barbuda',
      value: '+1268',
      text: '+1268 (Antigua and Barbuda)',
  },
  {
      name: 'Argentina',
      value: '+54',
      text: '+54 (Argentina)',
  },
  {
      name: 'Armenia',
      value: '+374',
      text: '+374 (Armenia)',
  },
  {
      name: 'Aruba',
      value: '+297',
      text: '+297 (Aruba)',
  },
  {
      name: 'Australia',
      value: '+61',
      text: '+61 (Australia)',
  },
  {
      name: 'Austria',
      value: '+43',
      text: '+43 (Austria)',
  },
  {
      name: 'Azerbaijan',
      value: '+994',
      text: '+994 (Azerbaijan)',
  },
  {
      name: 'Bahamas',
      value: '+1242',
      text: '+1242 (Bahamas)',
  },
  {
      name: 'Bahrain',
      value: '+973',
      text: '+973 (Bahrain)',
  },
  {
      name: 'Bangladesh',
      value: '+880',
      text: '+880 (Bangladesh)',
  },
  {
      name: 'Barbados',
      value: '+1246',
      text: '+1246 (Barbados)',
  },
  {
      name: 'Belarus',
      value: '+375',
      text: '+375 (Belarus)',
  },
  {
      name: 'Belgium',
      value: '+32',
      text: '+32 (Belgium)',
  },
  {
      name: 'Belize',
      value: '+501',
      text: '+501 (Belize)',
  },
  {
      name: 'Benin',
      value: '+229',
      text: '+229 (Benin)',
  },
  {
      name: 'Bermuda',
      value: '+1441',
      text: '+1441 (Bermuda)',
  },
  {
      name: 'Bhutan',
      value: '+975',
      text: '+975 (Bhutan)',
  },
  {
      name: 'Bolivia, Plurinational State of',
      value: '+591',
      text: '+591 (Bolivia, Plurinational State of)',
  },
  {
      name: 'Bosnia and Herzegovina',
      value: '+387',
      text: '+387 (Bosnia and Herzegovina)',
  },
  {
      name: 'Botswana',
      value: '+267',
      text: '+267 (Botswana)',
  },
  {
      name: 'Brazil',
      value: '+55',
      text: '+55 (Brazil)',
  },
  {
      name: 'British Indian Ocean Territory',
      value: '+246',
      text: '+246 (British Indian Ocean Territory)',
  },
  {
      name: 'Brunei Darussalam',
      value: '+673',
      text: '+673 (Brunei Darussalam)',
  },
  {
      name: 'Bulgaria',
      value: '+359',
      text: '+359 (Bulgaria)',
  },
  {
      name: 'Burkina Faso',
      value: '+226',
      text: '+226 (Burkina Faso)',
  },
  {
      name: 'Burundi',
      value: '+257',
      text: '+257 (Burundi)',
  },
  {
      name: 'Cambodia',
      value: '+855',
      text: '+855 (Cambodia)',
  },
  {
      name: 'Cameroon',
      value: '+237',
      text: '+237 (Cameroon)',
  },
  {
      name: 'Canada',
      value: '+1',
      text: '+1 (Canada)',
  },
  {
      name: 'Cape Verde',
      value: '+238',
      text: '+238 (Cape Verde)',
  },
  {
      name: 'Cayman Islands',
      value: '+1345',
      text: '+1345 (Cayman Islands)',
  },
  {
      name: 'Central African Republic',
      value: '+236',
      text: '+236 (Central African Republic)',
  },
  {
      name: 'Chad',
      value: '+235',
      text: '+235 (Chad)',
  },
  {
      name: 'Chile',
      value: '+56',
      text: '+56 (Chile)',
  },
  {
      name: 'China',
      value: '+86',
      text: '+86 (China)',
  },
  {
      name: 'Christmas Island',
      value: '+61',
      text: '+61 (Christmas Island)',
  },
  {
      name: 'Cocos (Keeling) Islands',
      value: '+61',
      text: '+61 (Cocos (Keeling) Islands)',
  },
  {
      name: 'Colombia',
      value: '+57',
      text: '+57 (Colombia)',
  },
  {
      name: 'Comoros',
      value: '+269',
      text: '+269 (Comoros)',
  },
  {
      name: 'Congo',
      value: '+242',
      text: '+242 (Congo)',
  },
  {
      name: 'Congo, The Democratic Republic of the Congo',
      value: '+243',
      text: '+243 (Congo, The Democratic Republic of the Congo)',
  },
  {
      name: 'Cook Islands',
      value: '+682',
      text: '+682 (Cook Islands)',
  },
  {
      name: 'Costa Rica',
      value: '+506',
      text: '+506 (Costa Rica)',
  },
  {
      name: 'Cote d\'Ivoire',
      value: '+225',
      text: '+225 (Cote d\'Ivoire)',
  },
  {
      name: 'Croatia',
      value: '+385',
      text: '+385 (Croatia)',
  },
  {
      name: 'Cuba',
      value: '+53',
      text: '+53 (Cuba)',
  },
  {
      name: 'Cyprus',
      value: '+357',
      text: '+357 (Cyprus)',
  },
  {
      name: 'Czech Republic',
      value: '+420',
      text: '+420 (Czech Republic)',
  },
  {
      name: 'Denmark',
      value: '+45',
      text: '+45 (Denmark)',
  },
  {
      name: 'Djibouti',
      value: '+253',
      text: '+253 (Djibouti)',
  },
  {
      name: 'Dominica',
      value: '+1767',
      text: '+1767 (Dominica)',
  },
  {
      name: 'Dominican Republic',
      value: '+1849',
      text: '+1849 (Dominican Republic)',
  },
  {
      name: 'Ecuador',
      value: '+593',
      text: '+593 (Ecuador)',
  },
  {
      name: 'Egypt',
      value: '+20',
      text: '+20 (Egypt)',
  },
  {
      name: 'El Salvador',
      value: '+503',
      text: '+503 (El Salvador)',
  },
  {
      name: 'Equatorial Guinea',
      value: '+240',
      text: '+240 (Equatorial Guinea)',
  },
  {
      name: 'Eritrea',
      value: '+291',
      text: '+291 (Eritrea)',
  },
  {
      name: 'Estonia',
      value: '+372',
      text: '+372 (Estonia)',
  },
  {
      name: 'Ethiopia',
      value: '+251',
      text: '+251 (Ethiopia)',
  },
  {
      name: 'Falkland Islands (Malvinas)',
      value: '+500',
      text: '+500 (Falkland Islands (Malvinas))',
  },
  {
      name: 'Faroe Islands',
      value: '+298',
      text: '+298 (Faroe Islands)',
  },
  {
      name: 'Fiji',
      value: '+679',
      text: '+679 (Fiji)',
  },
  {
      name: 'Finland',
      value: '+358',
      text: '+358 (Finland)',
  },
  {
      name: 'France',
      value: '+33',
      text: '+33 (France)',
  },
  {
      name: 'French Guiana',
      value: '+594',
      text: '+594 (French Guiana)',
  },
  {
      name: 'French Polynesia',
      value: '+689',
      text: '+689 (French Polynesia)',
  },
  {
      name: 'Gabon',
      value: '+241',
      text: '+241 (Gabon)',
  },
  {
      name: 'Gambia',
      value: '+220',
      text: '+220 (Gambia)',
  },
  {
      name: 'Georgia',
      value: '+995',
      text: '+995 (Georgia)',
  },
  {
      name: 'Germany',
      value: '+49',
      text: '+49 (Germany)',
  },
  {
      name: 'Ghana',
      value: '+233',
      text: '+233 (Ghana)',
  },
  {
      name: 'Gibraltar',
      value: '+350',
      text: '+350 (Gibraltar)',
  },
  {
      name: 'Greece',
      value: '+30',
      text: '+30 (Greece)',
  },
  {
      name: 'Greenland',
      value: '+299',
      text: '+299 (Greenland)',
  },
  {
      name: 'Grenada',
      value: '+1473',
      text: '+1473 (Grenada)',
  },
  {
      name: 'Guadeloupe',
      value: '+590',
      text: '+590 (Guadeloupe)',
  },
  {
      name: 'Guam',
      value: '+1671',
      text: '+1671 (Guam)',
  },
  {
      name: 'Guatemala',
      value: '+502',
      text: '+502 (Guatemala)',
  },
  {
      name: 'Guernsey',
      value: '+44',
      text: '+44 (Guernsey)',
  },
  {
      name: 'Guinea',
      value: '+224',
      text: '+224 (Guinea)',
  },
  {
      name: 'Guinea-Bissau',
      value: '+245',
      text: '+245 (Guinea-Bissau)',
  },
  {
      name: 'Guyana',
      value: '+595',
      text: '+595 (Guyana)',
  },
  {
      name: 'Haiti',
      value: '+509',
      text: '+509 (Haiti)',
  },
  {
      name: 'Holy See (Vatican City State)',
      value: '+379',
      text: '+379 (Holy See (Vatican City State))',
  },
  {
      name: 'Honduras',
      value: '+504',
      text: '+504 (Honduras)',
  },
  {
      name: 'Hong Kong',
      value: '+852',
      text: '+852 (Hong Kong)',
  },
  {
      name: 'Hungary',
      value: '+36',
      text: '+36 (Hungary)',
  },
  {
      name: 'Iceland',
      value: '+354',
      text: '+354 (Iceland)',
  },
  {
      name: 'India',
      value: '+91',
      text: '+91 (India)',
  },
  {
      name: 'Indonesia',
      value: '+62',
      text: '+62 (Indonesia)',
  },
  {
      name: 'Iran, Islamic Republic of Persian Gulf',
      value: '+98',
      text: '+98 (Iran, Islamic Republic of Persian Gulf)',
  },
  {
      name: 'Iraq',
      value: '+964',
      text: '+964 (Iraq)',
  },
  {
      name: 'Ireland',
      value: '+353',
      text: '+353 (Ireland)',
  },
  {
      name: 'Isle of Man',
      value: '+44',
      text: '+44 (Isle of Man)',
  },
  {
      name: 'Israel',
      value: '+972',
      text: '+972 (Israel)',
  },
  {
      name: 'Italy',
      value: '+39',
      text: '+39 (Italy)',
  },
  {
      name: 'Jamaica',
      value: '+1876',
      text: '+1876 (Jamaica)',
  },
  {
      name: 'Japan',
      value: '+81',
      text: '+81 (Japan)',
  },
  {
      name: 'Jersey',
      value: '+44',
      text: '+44 (Jersey)',
  },
  {
      name: 'Jordan',
      value: '+962',
      text: '+962 (Jordan)',
  },
  {
      name: 'Kazakhstan',
      value: '+77',
      text: '+77 (Kazakhstan)',
  },
  {
      name: 'Kenya',
      value: '+254',
      text: '+254 (Kenya)',
  },
  {
      name: 'Kiribati',
      value: '+686',
      text: '+686 (Kiribati)',
  },
  {
      name: 'Korea, Democratic People\'s Republic of Korea',
      value: '+850',
      text: '+850 (Korea, Democratic People\'s Republic of Korea)',
  },
  {
      name: 'Korea, Republic of South Korea',
      value: '+82',
      text: '+82 (Korea, Republic of South Korea)',
  },
  {
      name: 'Kuwait',
      value: '+965',
      text: '+965 (Kuwait)',
  },
  {
      name: 'Kyrgyzstan',
      value: '+996',
      text: '+996 (Kyrgyzstan)',
  },
  {
      name: 'Laos',
      value: '+856',
      text: '+856 (Laos)',
  },
  {
      name: 'Latvia',
      value: '+371',
      text: '+371 (Latvia)',
  },
  {
      name: 'Lebanon',
      value: '+961',
      text: '+961 (Lebanon)',
  },
  {
      name: 'Lesotho',
      value: '+266',
      text: '+266 (Lesotho)',
  },
  {
      name: 'Liberia',
      value: '+231',
      text: '+231 (Liberia)',
  },
  {
      name: 'Libyan Arab Jamahiriya',
      value: '+218',
      text: '+218 (Libyan Arab Jamahiriya)',
  },
  {
      name: 'Liechtenstein',
      value: '+423',
      text: '+423 (Liechtenstein)',
  },
  {
      name: 'Lithuania',
      value: '+370',
      text: '+370 (Lithuania)',
  },
  {
      name: 'Luxembourg',
      value: '+352',
      text: '+352 (Luxembourg)',
  },
  {
      name: 'Macao',
      value: '+853',
      text: '+853 (Macao)',
  },
  {
      name: 'Macedonia',
      value: '+389',
      text: '+389 (Macedonia)',
  },
  {
      name: 'Madagascar',
      value: '+261',
      text: '+261 (Madagascar)',
  },
  {
      name: 'Malawi',
      value: '+265',
      text: '+265 (Malawi)',
  },
  {
      name: 'Malaysia',
      value: '+60',
      text: '+60 (Malaysia)',
  },
  {
      name: 'Maldives',
      value: '+960',
      text: '+960 (Maldives)',
  },
  {
      name: 'Mali',
      value: '+223',
      text: '+223 (Mali)',
  },
  {
      name: 'Malta',
      value: '+356',
      text: '+356 (Malta)',
  },
  {
      name: 'Marshall Islands',
      value: '+692',
      text: '+692 (Marshall Islands)',
  },
  {
      name: 'Martinique',
      value: '+596',
      text: '+596 (Martinique)',
  },
  {
      name: 'Mauritania',
      value: '+222',
      text: '+222 (Mauritania)',
  },
  {
      name: 'Mauritius',
      value: '+230',
      text: '+230 (Mauritius)',
  },
  {
      name: 'Mayotte',
      value: '+262',
      text: '+262 (Mayotte)',
  },
  {
      name: 'Mexico',
      value: '+52',
      text: '+52 (Mexico)',
  },
  {
      name: 'Micronesia, Federated States of Micronesia',
      value: '+691',
      text: '+691 (Micronesia, Federated States of Micronesia)',
  },
  {
      name: 'Moldova',
      value: '+373',
      text: '+373 (Moldova)',
  },
  {
      name: 'Monaco',
      value: '+377',
      text: '+377 (Monaco)',
  },
  {
      name: 'Mongolia',
      value: '+976',
      text: '+976 (Mongolia)',
  },
  {
      name: 'Montenegro',
      value: '+382',
      text: '+382 (Montenegro)',
  },
  {
      name: 'Montserrat',
      value: '+1664',
      text: '+1664 (Montserrat)',
  },
  {
      name: 'Morocco',
      value: '+212',
      text: '+212 (Morocco)',
  },
  {
      name: 'Mozambique',
      value: '+258',
      text: '+258 (Mozambique)',
  },
  {
      name: 'Myanmar',
      value: '+95',
      text: '+95 (Myanmar)',
  },
  {
      name: 'Namibia',
      value: '+264',
      text: '+264 (Namibia)',
  },
  {
      name: 'Nauru',
      value: '+674',
      text: '+674 (Nauru)',
  },
  {
      name: 'Nepal',
      value: '+977',
      text: '+977 (Nepal)',
  },
  {
      name: 'Netherlands',
      value: '+31',
      text: '+31 (Netherlands)',
  },
  {
      name: 'Netherlands Antilles',
      value: '+599',
      text: '+599 (Netherlands Antilles)',
  },
  {
      name: 'New Caledonia',
      value: '+687',
      text: '+687 (New Caledonia)',
  },
  {
      name: 'New Zealand',
      value: '+64',
      text: '+64 (New Zealand)',
  },
  {
      name: 'Nicaragua',
      value: '+505',
      text: '+505 (Nicaragua)',
  },
  {
      name: 'Niger',
      value: '+227',
      text: '+227 (Niger)',
  },
  {
      name: 'Nigeria',
      value: '+234',
      text: '+234 (Nigeria)',
  },
  {
      name: 'Niue',
      value: '+683',
      text: '+683 (Niue)',
  },
  {
      name: 'Norfolk Island',
      value: '+672',
      text: '+672 (Norfolk Island)',
  },
  {
      name: 'Northern Mariana Islands',
      value: '+1670',
      text: '+1670 (Northern Mariana Islands)',
  },
  {
      name: 'Norway',
      value: '+47',
      text: '+47 (Norway)',
  },
  {
      name: 'Oman',
      value: '+968',
      text: '+968 (Oman)',
  },
  {
      name: 'Pakistan',
      value: '+92',
      text: '+92 (Pakistan)',
  },
  {
      name: 'Palau',
      value: '+680',
      text: '+680 (Palau)',
  },
  {
      name: 'Palestinian Territory, Occupied',
      value: '+970',
      text: '+970 (Palestinian Territory, Occupied)',
  },
  {
      name: 'Panama',
      value: '+507',
      text: '+507 (Panama)',
  },
  {
      name: 'Papua New Guinea',
      value: '+675',
      text: '+675 (Papua New Guinea)',
  },
  {
      name: 'Paraguay',
      value: '+595',
      text: '+595 (Paraguay)',
  },
  {
      name: 'Peru',
      value: '+51',
      text: '+51 (Peru)',
  },
  {
      name: 'Philippines',
      value: '+63',
      text: '+63 (Philippines)',
  },
  {
      name: 'Pitcairn',
      value: '+872',
      text: '+872 (Pitcairn)',
  },
  {
      name: 'Poland',
      value: '+48',
      text: '+48 (Poland)',
  },
  {
      name: 'Portugal',
      value: '+351',
      text: '+351 (Portugal)',
  },
  {
      name: 'Puerto Rico',
      value: '+1939',
      text: '+1939 (Puerto Rico)',
  },
  {
      name: 'Qatar',
      value: '+974',
      text: '+974 (Qatar)',
  },
  {
      name: 'Romania',
      value: '+40',
      text: '+40 (Romania)',
  },
  {
      name: 'Russia',
      value: '+7',
      text: '+7 (Russia)',
  },
  {
      name: 'Rwanda',
      value: '+250',
      text: '+250 (Rwanda)',
  },
  {
      name: 'Reunion',
      value: '+262',
      text: '+262 (Reunion)',
  },
  {
      name: 'Saint Barthelemy',
      value: '+590',
      text: '+590 (Saint Barthelemy)',
  },
  {
      name: 'Saint Helena, Ascension and Tristan Da Cunha',
      value: '+290',
      text: '+290 (Saint Helena, Ascension and Tristan Da Cunha)',
  },
  {
      name: 'Saint Kitts and Nevis',
      value: '+1869',
      text: '+1869 (Saint Kitts and Nevis)',
  },
  {
      name: 'Saint Lucia',
      value: '+1758',
      text: '+1758 (Saint Lucia)',
  },
  {
      name: 'Saint Martin',
      value: '+590',
      text: '+590 (Saint Martin)',
  },
  {
      name: 'Saint Pierre and Miquelon',
      value: '+508',
      text: '+508 (Saint Pierre and Miquelon)',
  },
  {
      name: 'Saint Vincent and the Grenadines',
      value: '+1784',
      text: '+1784 (Saint Vincent and the Grenadines)',
  },
  {
      name: 'Samoa',
      value: '+685',
      text: '+685 (Samoa)',
  },
  {
      name: 'San Marino',
      value: '+378',
      text: '+378 (San Marino)',
  },
  {
      name: 'Sao Tome and Principe',
      value: '+239',
      text: '+239 (Sao Tome and Principe)',
  },
  {
      name: 'Saudi Arabia',
      value: '+966',
      text: '+966 (Saudi Arabia)',
  },
  {
      name: 'Senegal',
      value: '+221',
      text: '+221 (Senegal)',
  },
  {
      name: 'Serbia',
      value: '+381',
      text: '+381 (Serbia)',
  },
  {
      name: 'Seychelles',
      value: '+248',
      text: '+248 (Seychelles)',
  },
  {
      name: 'Sierra Leone',
      value: '+232',
      text: '+232 (Sierra Leone)',
  },
  {
      name: 'Singapore',
      value: '+65',
      text: '+65 (Singapore)',
  },
  {
      name: 'Slovakia',
      value: '+421',
      text: '+421 (Slovakia)',
  },
  {
      name: 'Slovenia',
      value: '+386',
      text: '+386 (Slovenia)',
  },
  {
      name: 'Solomon Islands',
      value: '+677',
      text: '+677 (Solomon Islands)',
  },
  {
      name: 'Somalia',
      value: '+252',
      text: '+252 (Somalia)',
  },
  {
      name: 'South Africa',
      value: '+27',
      text: '+27 (South Africa)',
  },
  {
      name: 'South Sudan',
      value: '+211',
      text: '+211 (South Sudan)',
  },
  {
      name: 'South Georgia and the South Sandwich Islands',
      value: '+500',
      text: '+500 (South Georgia and the South Sandwich Islands)',
  },
  {
      name: 'Spain',
      value: '+34',
      text: '+34 (Spain)',
  },
  {
      name: 'Sri Lanka',
      value: '+94',
      text: '+94 (Sri Lanka)',
  },
  {
      name: 'Sudan',
      value: '+249',
      text: '+249 (Sudan)',
  },
  {
      name: 'Suriname',
      value: '+597',
      text: '+597 (Suriname)',
  },
  {
      name: 'Svalbard and Jan Mayen',
      value: '+47',
      text: '+47 (Svalbard and Jan Mayen)',
  },
  {
      name: 'Swaziland',
      value: '+268',
      text: '+268 (Swaziland)',
  },
  {
      name: 'Sweden',
      value: '+46',
      text: '+46 (Sweden)',
  },
  {
      name: 'Switzerland',
      value: '+41',
      text: '+41 (Switzerland)',
  },
  {
      name: 'Syrian Arab Republic',
      value: '+963',
      text: '+963 (Syrian Arab Republic)',
  },
  {
      name: 'Taiwan',
      value: '+886',
      text: '+886 (Taiwan)',
  },
  {
      name: 'Tajikistan',
      value: '+992',
      text: '+992 (Tajikistan)',
  },
  {
      name: 'Tanzania, United Republic of Tanzania',
      value: '+255',
      text: '+255 (Tanzania, United Republic of Tanzania)',
  },
  {
      name: 'Thailand',
      value: '+66',
      text: '+66 (Thailand)',
  },
  {
      name: 'Timor-Leste',
      value: '+670',
      text: '+670 (Timor-Leste)',
  },
  {
      name: 'Togo',
      value: '+228',
      text: '+228 (Togo)',
  },
  {
      name: 'Tokelau',
      value: '+690',
      text: '+690 (Tokelau)',
  },
  {
      name: 'Tonga',
      value: '+676',
      text: '+676 (Tonga)',
  },
  {
      name: 'Trinidad and Tobago',
      value: '+1868',
      text: '+1868 (Trinidad and Tobago)',
  },
  {
      name: 'Tunisia',
      value: '+216',
      text: '+216 (Tunisia)',
  },
  {
      name: 'Turkey',
      value: '+90',
      text: '+90 (Turkey)',
  },
  {
      name: 'Turkmenistan',
      value: '+993',
      text: '+993 (Turkmenistan)',
  },
  {
      name: 'Turks and Caicos Islands',
      value: '+1649',
      text: '+1649 (Turks and Caicos Islands)',
  },
  {
      name: 'Tuvalu',
      value: '+688',
      text: '+688 (Tuvalu)',
  },
  {
      name: 'Uganda',
      value: '+256',
      text: '+256 (Uganda)',
  },
  {
      name: 'Ukraine',
      value: '+380',
      text: '+380 (Ukraine)',
  },
  {
      name: 'United Arab Emirates',
      value: '+971',
      text: '+971 (United Arab Emirates)',
  },
  {
      name: 'United Kingdom',
      value: '+44',
      text: '+44 (United Kingdom)',
  },
  {
      name: 'United States',
      value: '+1',
      text: '+1 (United States)',
  },
  {
      name: 'Uruguay',
      value: '+598',
      text: '+598 (Uruguay)',
  },
  {
      name: 'Uzbekistan',
      value: '+998',
      text: '+998 (Uzbekistan)',
  },
  {
      name: 'Vanuatu',
      value: '+678',
      text: '+678 (Vanuatu)',
  },
  {
      name: 'Venezuela, Bolivarian Republic of Venezuela',
      value: '+58',
      text: '+58 (Venezuela, Bolivarian Republic of Venezuela)',
  },
  {
      name: 'Vietnam',
      value: '+84',
      text: '+84 (Vietnam)',
  },
  {
      name: 'Virgin Islands, British',
      value: '+1284',
      text: '+1284 (Virgin Islands, British)',
  },
  {
      name: 'Virgin Islands, U.S.',
      value: '+1340',
      text: '+1340 (Virgin Islands, U.S.)',
  },
  {
      name: 'Wallis and Futuna',
      value: '+681',
      text: '+681 (Wallis and Futuna)',
  },
  {
      name: 'Yemen',
      value: '+967',
      text: '+967 (Yemen)',
  },
  {
      name: 'Zambia',
      value: '+260',
      text: '+260 (Zambia)',
  },
  {
      name: 'Zimbabwe',
      value: '+263',
      text: '+263 (Zimbabwe)',
  },
];

const countryCodes = (phone?: string, name?: string) => {
    return phone ? countryCodesList.find((code) => (!name || code.name === name) && code.value === phone) : countryCodesList;
};

const lookupCountryCode = (phoneNumber: string): string | undefined => {
    let potentialCode = '';
    if (!phoneNumber.includes('+')) potentialCode += '+';
    for (const char of phoneNumber) {
        potentialCode += char;
        if (countryCodes(potentialCode)) {
            return potentialCode;
        }
    }
    return phoneNumber;
};

const getFormattedMobileNo = (mobileNo: string): string => {
    const countryCode = lookupCountryCode(mobileNo);
    if (!countryCode) return mobileNo;

    const prefixToRemove = mobileNo.includes('+') ? countryCode : countryCode.replace('+', '');
    const separator = mobileNo.includes('-') ? '' : '-';
    return mobileNo.replace(prefixToRemove, `${countryCode}${separator}`)
}

const getStoredMobileNo = (display?: string | null): string => {
  if (!display) return '';

  const raw = display.trim();

  let detectedCode = lookupCountryCode(raw) || null;
  let rest = '';

  if (raw.includes('-')) {
    const [left, ...restParts] = raw.split('-');
    rest = restParts.join('-');
    if (!detectedCode && left) {
      detectedCode = left.startsWith('+') ? left : `+${left}`;
    }
  } else if (detectedCode) {
    const codeWithPlus = detectedCode.startsWith('+') ? detectedCode : `+${detectedCode}`;
    const codeNoPlus = codeWithPlus.slice(1);
    if (raw.startsWith(codeWithPlus)) {
      rest = raw.slice(codeWithPlus.length);
      detectedCode = codeWithPlus;
    } else if (raw.startsWith(codeNoPlus)) {
      rest = raw.slice(codeNoPlus.length);
      detectedCode = codeWithPlus;
    } else {
      rest = raw.replace(detectedCode, '');
      detectedCode = codeWithPlus;
    }
  } else {
    rest = raw;
  }

  rest = (rest || '').replace(/[^0-9]/g, '');

  if (detectedCode) {
    const normalizedCode = detectedCode.startsWith('+') ? detectedCode : `+${detectedCode}`;
    return `${normalizedCode}${rest}`;
  }

  return rest;
};


export { countryCodesList, lookupCountryCode, getFormattedMobileNo, getStoredMobileNo };
export default countryCodes;
